import {
  ChangeDetectorRef,
  Directive,
  ViewChild,
} from '@angular/core';
import { Router } from '@angular/router';

import { CustomFormGroup as CustomFormGroupNew } from '@rs-bank/rs-forms-extention';

import { CustomFormGroup } from '../../../../../ui/custom-reactive-forms/custom-form-group';
import { PaymentWidgetsServiceService } from '../payment-widgets.service';

import { ChargeForWidget } from './charge-item/change-item-entites';
import { ChargeWidgetComponent } from './charge-widget/charge-widget.component';

@Directive()
export abstract class WidgetBaseDirective {

	@ViewChild(ChargeWidgetComponent, {static: true})
	public chargeWidget: ChargeWidgetComponent;

	public subscriptionsAbsence: boolean;
	public charges: Array<ChargeForWidget> = [];
	public searchForm: CustomFormGroup;
	public searchFormNew: CustomFormGroupNew;

	constructor(
		protected router: Router,
		protected paymentWidgetsServiceService: PaymentWidgetsServiceService,
		protected changeDetectorRef: ChangeDetectorRef,
	) { }

	public onAddSubscriptionClick(): void {
		this.router.navigate([
'settings',
'tab3',
]);
	}

	public abstract onTabSubscriptionActivate(): void;
	public abstract onTabSearchActivate(): void;
	public abstract search(): void;
}
